export default __webpack_public_path__ + "static/stop-it-now-logo-43deeab79bac823cbbaf2670323f0750.svg";